module.exports = __webpack_public_path__ + "static/media/agoda-logo-icon.466ef157.png";